/* eslint-disable sort-keys-fix/sort-keys-fix */
// NOTE: name should be lowercase as lowercase serializer is used.
export const QUESTION_CLONER_ROUTE = {
  name: 'questioncloner',
  route(): string[] {
    return ['/' + this.name];
  },
  DEFAULT: '',
  EDIT_QUESTIONS: {
    name: 'editquestions/:questionBucketId',
    route(questionBucketId: string): string[] {
      return [...QUESTION_CLONER_ROUTE.route(), 'editquestions', questionBucketId];
    }
  },
  VIEW_QUESTIONS: {
    name: 'viewquestions/:courseId/:questionStatus',
    route(courseId: string, questionStatus: string): string[] {
      return [...QUESTION_CLONER_ROUTE.route(), 'viewquestions', courseId, questionStatus];
    }
  }
};
